import React from "react";
import { CtaButton } from "./CtaButton";
import { SectionHeading } from "./SectionHeading";
import { situations } from "../data/page";
export function SituationsSection() {
  return <section className="bg-white px-4 py-16 sm:px-6 sm:py-24" data-id="element-319" data-mp="2nks97qkick8c">
      <div className="mx-auto max-w-6xl" data-id="element-320" data-mp="2nn4zqs4c02x0">
        <SectionHeading title="Do you recognize any of these situations?" subtitle="If any of these sound familiar, I created this resource with your learning and professional workflow in mind." data-id="element-321" data-mp="2imh0jj5y8frp" />

        <ul className="mt-12 grid gap-x-12 gap-y-8 md:grid-cols-2" data-id="element-322" data-mp="28vcksh8g8qvt">
          {situations.map(({
          icon: Icon,
          title,
          text
        }) => <li key={title} className="flex gap-4" data-id="element-323" data-mp="24sg9lbl8nx1w">
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-xl bg-navy-900 text-cta" data-id="element-324" data-mp="1zw92vgl0qhiw">
                <Icon className="h-6 w-6" aria-hidden="true" data-id="element-325" data-mp="1uv1v3hivlic8" />
              </span>
              <div data-id="element-326" data-mp="1pybcamfos8n4">
                <h3 className="text-lg font-bold leading-snug text-ink" data-id="element-327" data-mp="1pxtirxkes8iw">{title}</h3>
                <p className="mt-1.5 text-base leading-relaxed text-ink-soft" data-id="element-328" data-mp="2xv27yea42r9">{text}</p>
              </div>
            </li>)}
        </ul>

        <div className="mt-14 rounded-3xl bg-navy-900 px-6 py-10 text-center text-white sm:px-12 sm:py-14" data-id="element-329" data-mp="7rfquztzfkds">
          <p className="font-display text-3xl font-bold uppercase leading-tight sm:text-4xl" data-id="element-330" data-mp="3u57ebz0b1q0b">
            And it doesn't have to be <span className="text-cta" data-id="element-331" data-mp="lp4f8hn9d9nl">this disorganized.</span>
          </p>
          <div className="mx-auto mt-6 max-w-2xl space-y-4 text-lg leading-relaxed text-white/85" data-id="element-332" data-mp="qoh417xowqst">
            <p data-id="element-333" data-mp="br83bnmhyaof">The challenge isn't necessarily that you lack knowledge.</p>
            <p data-id="element-334" data-mp="btask5ftrzs3">
              Sometimes, the challenge is having the right information organized in a way that makes it easier to
              review, apply within your professional scope, and document consistently.
            </p>
            <p data-id="element-335" data-mp="31ga2oeqlmrgj">
              That's the purpose of <strong className="text-white" data-id="element-336" data-mp="31hbkr3618e7r">DIABETIC FOOT ASSESSMENT BLUEPRINT™</strong>. I
              brought the main educational topics together in one collection so you can review them in a more
              structured way.
            </p>
          </div>
        </div>

        <div className="mt-10" data-id="element-337" data-mp="y784p52ckit2">
          <CtaButton label="Get the complete reference" data-id="element-338" data-mp="y65fr2ol4qfs" />
        </div>
      </div>
    </section>;
}